import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './tailwind.output.css';
import './App.css';
import 'babel-polyfill'; 
import 'react-app-polyfill/ie11';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

setTimeout(() => {
  const elems = document.querySelectorAll(".tdBefore");
  elems.forEach((elem) => {
    const tdHeight = elem.parentNode.offsetHeight;
    if (tdHeight < elem.offsetHeight) {
      elem.parentNode.style = 'height: ' + elem.offsetHeight + 'px';
    }
  });
}, 1000);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
